import Serializer from "../../serializer";
import { ImportQuestionsData } from "./models";
import { IQuestionForm } from "../../../modules/QuestionForm/QuestionForm";

export function serializeImportQuestionsData(data: ImportQuestionsData) {
	return Serializer.serialize("questions", data);
}

export function serializeQuestionData(data: IQuestionForm) {
	return Serializer.serialize("questions", data);
}
